module.exports = [{
      plugin: require('/home/circleci/repo/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    }]
